<template>
  <div></div>
</template>
  
<script>
export default {
  name: "ForgotPasswordView",
  components: {},
};
</script>